const Sistema = {
  PORTAL_EGRESSO: 85,
};

export default Sistema;
